module.exports = require('./lodash.js');


/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/index.js
 ** module id = 206
 ** module chunks = 0
 **/